import { Button } from '@bennows/boows-react';
import { MessageSquare } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAssistant } from './AssistantProvider';

/** The header button that toggles the side panel (spec 110 section 4.15.6); absent when the assistant is not offered. */
export function AssistantButton() {
  const { t } = useTranslation();
  const { available, open, opened, phone, toggle, buttonRef } = useAssistant();
  if (!available) return null;
  // On a phone the entry is an icon button among the page tools (credit pill, search, bell).
  if (phone) {
    return (
      <Button ref={buttonRef} variant="ghost" iconOnly aria-label={t('assistant.button')} aria-expanded={open} aria-controls={opened ? 'assistant-panel' : undefined} onClick={toggle}>
        <MessageSquare aria-hidden="true" />
      </Button>
    );
  }
  return (
    <Button
      ref={buttonRef}
      variant="primary"
      iconPrefix={<MessageSquare aria-hidden="true" />}
      aria-expanded={open}
      aria-controls={opened ? 'assistant-panel' : undefined}
      onClick={toggle}
    >
      {t('assistant.button')}
    </Button>
  );
}
